<template>
<div v-if="data_programs[0]" style="padding:2em;">

<div v-if="isLoading" class="loading">Loading&#8230;</div> 

<!-- CHECK IF ADDING NEW  -->
<!-- <div v-if="data_programs[0].prog_ID == 0" class="columns is-gapless" style="margin-bottom:0em;">
    <div class="column is-size-5 has-text-weight-bold is-12 has-background-success">
        NEW PROGRAM
    </div>
</div> -->


<div class="columns is-gapless" style="margin-top:-2em;">
    <div class="column is-10 mt-2 has-text-weight-bold is-size-4">PROGRAMS </div>
    <div class="column is-2">
        <button @click="program_add_program()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
</div>


<!-- //PROGRAMS  -->
<div class="box has-background-grey">
<div class="columns is-gapless is-centered is-multiline" v-for="(data,index) in data_programs" :key="index" style="margin-bottom:.8em;">
<div class="column is-10">
    <CompProgProg :data="data"
    :data_comp="data_prog_competences"
    :data_cour="data_prog_courses"
     :key="randomKey()">  </CompProgProg>
</div>
</div>
</div>



<!-- <div class="column colBorder is-2">
<div class="columns is-gapless is-multiline">
  <div class="column has-text-centered is-12 has-text-weight-bold has-text-danger" style="margin-bottom:-.2em;"> 
    <button @click="program_delete_confirm(index,data_programs[index].prog_CODE )" class="button is-fullwidth has-text-danger"><span class="icon mr-2 is-small has-text-danger"> <i class="fas fa-trash-alt"></i> </span>DELETE</button>
  </div> 
    <div v-if="+data_programs[index].isChanged" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
      <button @click="program_save(index)" class="button is-success is-fullwidth"><span class="icon is-small has-text-white"> <i class="fas fa-save"></i> </span>&nbsp;&nbsp;&nbsp;SAVE</button>
    </div>
    <div v-else-if="+data_programs[index].doDelete" class="column has-text-centered is-12 has-text-weight-bold is-size-6" style="margin-bottom:-.2em;"> 
          <div class="columns is-gapless">
              <div class="column colBorder is-4">
                    <button @click="data_programs[index].doDelete = false" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span></button>
              </div>
              <div class="column colBorder is-8">
                    <button @click="program_delete_execute(index)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-check-circle"></i> </span>&nbsp;&nbsp;&nbsp;DELETE</button>
              </div>
          </div>
    </div>
</div></div> -->








<!-- <div v-if="prog_aec" class="columns is-centered is-vcentered is-gapless is-multiline" style="margin-bottom:0em;"> 
    <div class="column is-1">
        <button @click="get_competences()" class="button is-fullwidth has-background-success has-text-white"><span class="icon"><i class="fas fa-plus"></i></span>     </button> 
    </div>
    <div class="column is-2 is-size-7 has-text-weight-bold has-text-success">&nbsp;&nbsp;&nbsp;ADD COMPETENCE</div>
    <div v-if="!new__show" class="column is-9"></div>
        <div v-if="new__show" class="column is-2">
                <div class="control">
                <div class="select is-fullwidth">
                    <select  v-model="new__id">
                        <option v-for="(data,index) in data_options" :value="data.comp_ID"  :key="index" >{{ data.comp_CODE }}</option>
                    </select>
                </div>
                </div>
        </div>
        <div v-if="new__show" class="column is-2">
            <div class="columns is-gapless">
                <div class="column colBorder is-4">
                    <button @click="new__show=false" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span></button>
                </div>
                <div class="column colBorder is-8">
                    <button @click="program_add_competence(data_programs[index].prog_ID)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-check-circle"></i> </span>&nbsp;&nbsp;&nbsp;ADD</button>
                </div>
            </div>
        </div>

    <div class="column is-5"></div>

    <div class="column is-12">
    <CompPedCompetence :prog_id="prog_id" :key="compKey"> </CompPedCompetence>
    </div>

</div> -->

<!-- NO AEC !!!! -->

<!-- <div v-else class="columns is-centered is-vcentered is-gapless is-multiline" style="margin-bottom:0em;"> 
    <div class="column is-1">
        <button @click="get_courses()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
    <div class="column is-2 is-size-7 has-text-weight-bold has-text-success">&nbsp;&nbsp;&nbsp;ADD COURSE</div>
    <div v-if="!new__show" class="column is-9"></div>


<div v-if="new__show" class="column is-2">
        <div class="control">
        <div class="select is-fullwidth">
            <select  v-model="new__id">
                <option v-for="(data,index) in data_options" :value="data.cour_ID"  :key="index" >{{ data.cour_CODE }}</option>
            </select>
        </div>
        </div>
</div>

<div v-if="new__show" class="column is-2">
    <div class="columns is-gapless">
        <div class="column colBorder is-4">
            <button @click="new__show=false" class="button has-text-danger is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-danger fas fa-window-close"></i> </span></button>
        </div>
        <div class="column colBorder is-8">
            <button @click="program_add_course(data_programs[index].prog_ID)" class="button has-text-success is-fullwidth"><span class="icon is-small has-text-grey"> <i class=" has-text-success fas fa-check-circle"></i> </span>&nbsp;&nbsp;&nbsp;ADD</button>
        </div>
    </div>
</div>

    <div class="column is-5"></div>
    <div class="column is-10">
    <CompPedCourse :prog_id='prog_id' :comp_id='0' :key="compKey"> </CompPedCourse>
    </div>
</div> -->





<!-- END CHECKING IF SHOWING DETAILS  <CompPedCourse :prog_id="prog_id" :comp_id='0'> </CompPedCourse>-->





</div>
</template>

<script>
import axios from 'axios'
import CompProgProg from "@/views/Admin/Comp_Admin_Ped_Program_Program"

export default {
  name: 'PedPrograms',
  props: [ ],
  components: {CompProgProg},

    data() {
        return {
            isLoading:false,
            data_programs:[],
            
data_prog_competences:[],
data_prog_courses:[],

            prog_id : 0,
            prog_aec : false,


data_options:[], // HOLDS COMPS OR COURS FOR ADDING
new__id:0,
new__show:false,

//PROGRAM FEES

show_fees:false, 

compKey:0,
        }
    },


created() {
    this.get_programs() 
},

methods: {

get_programs:function() {

// GET COURSES AND POND FOR NEW ....

    this.isLoading = true;
    var query = "SELECT *, 0 as isChanged, 0 as doDelete, 0 as showDetails, 0 as showFees FROM myMEQ_PROGRAM ORDER BY prog_ID DESC"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_programs = res.data

    var query = "SELECT 0 as isSelected,comp_ID AS id, comp_CODE AS code, comp_TITRE_F AS descF, comp_TITRE_E AS descE FROM MyMEQ_COMPETENCE ORDER BY comp_CODE"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_prog_competences = res.data

    var query = "SELECT 0 as isSelected,cour_ID AS id, cour_CODE AS code, cour_TITRE_F AS descF, cour_TITRE_E AS descE FROM MyMEQ_COUR ORDER BY cour_CODE"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
        this.data_prog_courses = res.data

        this.isLoading = false;

    });    });    });
},


program_add_program:function() {

// CHECK IF NOTHING
if (this.data_programs.length == 0) {
this.data_programs.unshift(
    {prog_ID:0 , prog_CODE:'' ,prog_TITRE_F:'' , prog_TITRE_E:'' , prog_YEAR:'' ,  prog_CODEPLUS:'' , prog_blnAEC:true} 
); return;}


if (this.data_programs[0].prog_ID == 0) {return;}// CHECK IF ALREADY ONE NEW

// HERE -- ALL GOOD ??
this.data_programs.unshift(
    {prog_ID:0 , prog_CODE:'' ,prog_TITRE_F:'' , prog_TITRE_E:'' , prog_YEAR:'' ,  prog_CODEPLUS:'' , prog_blnAEC:true} 
);


},



program_add_course:function(prog) {
var query = "INSERT INTO MyMEQ_RELATION (prog_ID, cour_ID) VALUES (" + prog + "," + this.new__id + ")"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    this.compKey = ++this.compKey + 1
    this.new_cour_show=false
});
},

program_add_competence:function(prog) {

var query = "INSERT INTO MyMEQ_RELATION (prog_ID, comp_ID) VALUES (" + prog + "," + this.new__id + ")"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
    this.compKey = ++this.compKey + 1
    this.new_cour_show=false
});
},

get_competences:function() {
    this.isLoading = true;
// GET LIST OF COMPETENCES FOR ADDING TO PROG ....
    var query = "SELECT * FROM MyMEQ_COMPETENCE ORDER BY comp_CODE"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
            this.data_options = res.data
            this.isLoading = false;
            this.new__id = 0
            this.new__show = true; 
    });
},
get_courses:function() {
    this.isLoading = true;
// GET LIST OF COURSES FOR ADDING TO POND ....
    var query = "SELECT * FROM myMEQ_COUR ORDER BY cour_CODE"
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => { 
            this.data_options = res.data
            this.isLoading = false;
            this.new__id = 0
            this.new__show = true; 
    });
},

program_new:function() {
// CALLED FROM ADMIN_PED !!!!

// CHECK IF NOTHING
if (this.data_programs.length == 0) {
  this.data_programs.unshift({prog_ID:0 , isChanged:0 , doDelete:0, showDetails:0 ,staff_Nom:'',prog_CODE:'',prog_YEAR:'',prog_CODEPLUS:'',prog_TITRE_F:'',prog_TITRE_E:'',prog_blnAEC:false})
  return;
}


if (this.data_programs[0].prog_ID == 0) {return;}// CHECK IF ALREADY ONE NEW
  this.data_programs.unshift(
    {prog_ID:0 , isChanged:0 , doDelete:0, showDetails:0 ,staff_Nom:'',prog_CODE:'',prog_YEAR:'',prog_CODEPLUS:'',prog_TITRE_F:'',prog_TITRE_E:'',prog_blnAEC:false}
  )
},

 




program_get_courses:function(index) {
    if (this.data_programs[index].showDetails) {this.data_programs[index].showDetails = false ; return}
    this.prog_aec = +this.data_programs[index].prog_blnAEC
    this.prog_id = this.data_programs[index].prog_ID
    this.data_programs[index].showDetails = true
},

program_save:function(index) {

var query
if (this.data_programs[index].prog_ID == 0) {
  // INSERT
      query = "INSERT INTO myMEQ_PROGRAM (prog_CODE,prog_blnAEC) VALUES ('',0);SELECT MAX(prog_ID) AS newID FROM myMEQ_PROGRAM"
      axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
      .then(res => { 
          this.data_programs[index].prog_ID = res.data[0].newID

          query = "UPDATE myMEQ_PROGRAM SET " 
          query +=  " prog_CODE = '" + this.data_programs[index].prog_CODE
          query +=  "', prog_TITRE_F = '" + this.data_programs[index].prog_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', prog_TITRE_E = '" + this.data_programs[index].prog_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', prog_YEAR = '" + this.data_programs[index].prog_YEAR
          query +=  "', prog_CODEPLUS = '" + this.data_programs[index].prog_CODEPLUS
          query +=  "', prog_blnAEC = " + +this.data_programs[index].prog_blnAEC
          query +=  " WHERE prog_ID = " + this.data_programs[index].prog_ID

console.log(query)

          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_programs[index].isChanged = false
          });
  });
}
else // UPDATE
{ 
          query = "UPDATE myMEQ_PROGRAM SET " 
          query +=  " prog_CODE = '" + this.data_programs[index].prog_CODE
          query +=  "', prog_TITRE_F = '" + this.data_programs[index].prog_TITRE_F.trim().replace(/'/g,"''")
          query +=  "', prog_TITRE_E = '" + this.data_programs[index].prog_TITRE_E.trim().replace(/'/g,"''")
          query +=  "', prog_YEAR = '" + this.data_programs[index].prog_YEAR
          query +=  "', prog_CODEPLUS = '" + this.data_programs[index].prog_CODEPLUS
          query +=  "', prog_blnAEC = " + +this.data_programs[index].prog_blnAEC
          query +=  " WHERE prog_ID = " + this.data_programs[index].prog_ID
console.log(query)
          axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
          .then(res => { 
              this.$snotify.success('SAVED!!' , {timeout: 1000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",});
              this.data_programs[index].isChanged = false
          });

}

},
// END SAVE 








// GENERATE A NEW ID! 
randomKey:function() {
return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
});},

} // END METHODS




} // END EXPORT
</script>